import { render, staticRenderFns } from "./search-duoxuan.vue?vue&type=template&id=63853102&scoped=true&"
import script from "./search-duoxuan.vue?vue&type=script&lang=ts&"
export * from "./search-duoxuan.vue?vue&type=script&lang=ts&"
import style0 from "./search-duoxuan.vue?vue&type=style&index=0&id=63853102&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63853102",
  null
  
)

export default component.exports